<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Movimentação de Caixa</app-titulo>
      <div class="header-buttons">
        <app-botao
          *ngIf="!caixaOpen && !readonlyMode && (viewMenu('caixaHigienizacao', 'incluir') || viewMenu('caixaPatio', 'incluir'))"
          type="primario"
          class="button"
          text="Abertura do Caixa"
          icon="assets/add.svg"
          (click)="openModalAberturaCaixa()"></app-botao>
        <app-botao
          *ngIf="caixaOpen && !readonlyMode && (viewMenu('caixaHigienizacao', 'incluir') || viewMenu('caixaPatio', 'incluir'))"
          type="primario"
          class="button"
          text="Fechar o Caixa"
          icon="assets/add.svg"
          (click)="openModalFechamentoCaixa()"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          [ariaPlaceholder]="'Baixar modelo'"
          text="Resumo do Caixa"
          icon="assets/exportar-excel.svg"
          (click)="openModalRelatoriosCaixa()"></app-botao>
        <app-botao
          *ngIf="caixaId"
          type="secundario"
          class="button"
          text="Exportar Excel (filtros)"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcelMovimentacoes()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem</div>
        <div class="align-button">
          <form
            [formGroup]="form"
            (change)="getMovimentacoesCaixa()"
            class="table-filters">
            <app-input
              type="number"
              label="Nº do Caixa"
              placeholder="Digite aqui"
              name="PK_CAIX"
              formControlName="PK_CAIX"
              width="100%"></app-input>
            <app-input
              type="select"
              label="Tipo de Caixa"
              placeholder="Selecione"
              name="NU_TIPO_CAIX"
              formControlName="NU_TIPO_CAIX"
              width="100%"
              [selectData]="tipoCaixaOptions"
              (ngModelChange)="onChangeTipoCaixa($event)"></app-input>
            <app-input
              label="Placa do Cavalo"
              placeholder="Digite aqui"
              name="TX_PLCA_CAVA"
              mask="AAA-0A00"
              formControlName="TX_PLCA_CAVA"
              width="100%"></app-input>
            <app-input
              type="select"
              label="Modo de Pagamento"
              placeholder="Selecione"
              name="NU_TIPO_PGMT"
              formControlName="NU_TIPO_PGMT"
              width="100%"
              [selectData]="modoPagamentoOptions"
              (ngModelChange)="onChangeModoPagamento($event)"></app-input>
            <app-input
              type="select"
              label="Serviço"
              placeholder="Selecione"
              name="FK_SRVC"
              formControlName="FK_SRVC"
              width="100%"
              [selectData]="servicoOptions"></app-input>
            <app-input
              type="select"
              label="Tipo Movimentação"
              placeholder="Selecione"
              name="NU_MOVM_CAIX"
              formControlName="NU_MOVM_CAIX"
              width="100%"
              [selectData]="movimentacaoCaixaOptions"
              (ngModelChange)="onChangeMovimentacaoCaixa($event)"></app-input>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_PGMT_SAID_INIC"
              formControlName="DT_PGMT_SAID_INIC"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Fim"
              placeholder="Digite aqui"
              name="DT_PGMT_SAID_FIM"
              formControlName="DT_PGMT_SAID_FIM"
              width="100%"></app-input>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
      <div *ngIf="caixaId" class="rodape-tabela">
        <div class="botoes">
          <button
            *ngIf="viewMenu('cadastrarSuprimento', 'editar') && !readonlyMode"
            class="sangria-suprimento-button"
            (click)="openModalSuprimentos()">
            Suprimentos +
          </button>
          <button
            *ngIf="viewMenu('cadastrarSangria', 'editar') && !readonlyMode"
            class="sangria-suprimento-button"
            (click)="openModalSangria()">
            Sangria -
          </button>
        </div>
        <h2 class="valor">
          <!-- Valor Total do Caixa:
          {{
            valorTotalCaixa.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }} -->
        </h2>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form
      [formGroup]="form"
      (ngModelChange)="getMovimentacoesCaixa()"
      class="table-filters">
      <app-input
        type="number"
        label="Nº do Caixa"
        placeholder="Digite aqui"
        name="PK_CAIX"
        formControlName="PK_CAIX"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"></app-input>
      <app-input
        type="select"
        label="Modo de Pagamento"
        placeholder="Selecione"
        name="NU_TIPO_PGMT"
        formControlName="NU_TIPO_PGMT"
        width="100%"
        [selectData]="modoPagamentoOptions"></app-input>
      <app-input
        type="select"
        label="Serviço"
        placeholder="Selecione"
        name="FK_SRVC"
        formControlName="FK_SRVC"
        width="100%"
        [selectData]="servicoOptions"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_PGMT_SAID_INIC"
        formControlName="DT_PGMT_SAID_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Fim"
        placeholder="Digite aqui"
        name="DT_PGMT_SAID_FIM"
        formControlName="DT_PGMT_SAID_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
    <div *ngIf="caixaId" class="rodape-tabela">
      <div class="botoes">
        <button
          *ngIf="!readonlyMode"
          class="sangria-suprimento-button"
          (click)="openModalSuprimentos()">
          Suprimentos +
        </button>
        <button
          *ngIf="!readonlyMode"
          class="sangria-suprimento-button"
          (click)="openModalSangria()">
          Sangria -
        </button>
      </div>
      <h2 class="valor">
        <!-- Valor Total do Caixa:
        {{
          valorTotalCaixa.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }} -->
      </h2>
    </div>
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="TOTAL_PAGES"
      (selectedPage)="setPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
